import React, { useEffect, useMemo } from 'react'
import {
  CommentItemDateBellowPlayer,
  CommentItemTextBellowPlayer,
  MainRailCommits,
  NameItemTextBellowPlayer,
  PlayerWrap,
  RailFirstItemDescriptionBellowPlayer,
  RailFirstItemImage,
  RailItemFirsItemWrap,
} from './MainProgramMenu.style'
import { ILightRailItem } from '../../../types'
import { BlockedAdsImage } from '../BlockAds'
import { useDetectAdBlock } from 'adblock-detect-react'
import { useTaboola } from '../../../components/Taboola/useTaboola'
import { useOttStore } from '../../store/ottStore'
import { mediaCdn } from '../../../components/Player/Helpers'
import dynamic from 'next/dynamic'

const Player = dynamic(() => import('../Player/Player'), { ssr: false })

export const MainProgramMenu = ({ data }: { data: ILightRailItem | null }) => {
  const blockAds = useDetectAdBlock()
  const { taboolaInfo } = useTaboola()
  const blockedTaboola = useMemo(
    () => taboolaInfo.scriptLoad === 'failed',
    [taboolaInfo]
  )
  const { setEpisodeDescription } = useOttStore()

  const posterUrl = useMemo(() => {
    let found: string | false = ''
    let url = ''

    if (!data) {
      return {
        desktop: `${mediaCdn}q_auto:best/v1750236296/assets/2025/default.webp`,
        mobile: `${mediaCdn}c_scale,q_auto:best,w_320/v1750236296/assets/2025/default.webp`,
      }
    }
    if (data.images.length > 0) {
      found =
        data.images.find(
          img => img.ratio === '16x9' || img.imageTypeName === '16x9'
        )?.url || false
      if (found) {
        url = found
      } else {
        url = data.images[0].url
      }
    }
    return {
      desktop: url + '/width/1020/height/574',
      mobile: url + '/width/320/height/180',
    }
  }, [data])

  const formatDate = (timestamp: number): string => {
    const date = new Date(timestamp * 1000) // convert seconds to ms
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = String(date.getFullYear())
    return `${day}.${month}.${year}`
  }

  useEffect(() => {
    if (data) {
      setEpisodeDescription(data?.description || '')
    }
  }, [data, setEpisodeDescription])

  if (!data) {
    return null
  }

  return (
    <RailItemFirsItemWrap>
      <PlayerWrap data-external={data?.externalId} data-media={data?.id}>
        <RailFirstItemImage>
          {blockAds || blockedTaboola ? (
            <BlockedAdsImage />
          ) : (
            <Player
              MEDIAID={'' + data?.id}
              POSTER={posterUrl.desktop}
              REFERENCE_ID={data.externalId}
              DURATION={parseInt(data.metas.RunTime as string) || 0}
              entryId={data.entryId}
            />
          )}
          <div className='overlay-image'></div>
        </RailFirstItemImage>
      </PlayerWrap>
      <RailFirstItemDescriptionBellowPlayer>
        <MainRailCommits>
          <NameItemTextBellowPlayer>{data?.name}</NameItemTextBellowPlayer>
          <CommentItemTextBellowPlayer>
            {data?.description}
          </CommentItemTextBellowPlayer>
          <CommentItemDateBellowPlayer>
            {formatDate(data.createDate)}
          </CommentItemDateBellowPlayer>
        </MainRailCommits>
      </RailFirstItemDescriptionBellowPlayer>
    </RailItemFirsItemWrap>
  )
}
